/* eslint-disable */
export const arrayMove = (arr, fromIndex, toIndex) => {
	const newArray = arr.slice();
	const element = newArray[fromIndex];
    newArray.splice(fromIndex, 1);
	newArray.splice(toIndex, 0, element);
	return newArray;
};
